'use strict';

var NetSpillRateDataService = function NetSpillRateDataService(dataRetrieverService, dataRetrieverConstants) {
  var SCREEN = dataRetrieverConstants.ROM_ANALYSIS_SCREEN;
  var MODE = dataRetrieverConstants.ROM_ANALYSIS_DEMAND_PAX_MODE;
  var DATA_TYPE = 'net-spill-rates';
  function getData() {
    return dataRetrieverService.getDataRetriever(SCREEN, MODE).currentRequestParameters({
      noSpinner: true
    }).localSortApplied().retrieveComponentData(DATA_TYPE);
  }
  function startRetrievingData() {
    var searchCriteriaRulesPromise = dataRetrieverService.getDataRetriever(SCREEN, MODE).getSearchCriteriaRules();
    searchCriteriaRulesPromise.then(function (searchCriteriaRule) {
      dataRetrieverService.getDataRetriever(SCREEN, MODE).currentRequestParameters({
        noSpinner: true
      }).retrieveData(DATA_TYPE, searchCriteriaRule);
    });
  }
  return {
    getData: getData,
    startRetrievingData: startRetrievingData
  };
};
NetSpillRateDataService.$inject = ['DataRetrieverService', 'DataRetrieverConstantsService'];
module.exports = NetSpillRateDataService;